import { useCallback, useMemo } from "react"

import { intersectionBy, isFunction } from "lodash"
import { useSelector } from "react-redux"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTriangleExclamation } from "@fortawesome/pro-duotone-svg-icons"
import { faArrowRightArrowLeft } from "@fortawesome/pro-solid-svg-icons"

import ConfirmFormFooter from "../../../Components/antd/Forms/ConfirmFormFooter"
import { selectTranslate } from "../../../reducers/LocaleReducer/LocalReducer"
import { isNonEmptyArray } from "../../../utils"
import ColoredTag, { TagColors } from "../../../Components/shared/Lists/ColoredTag"
import { Properties } from "../../../utils/entities"
import { getConcurrentGroups } from "../../../utils/entities/sectionGroup"

const { ID } = Properties

const TransferSectionsPanel = ({ sources, destination, toTransfert, loading, onCancel, onConfirm }) => {
  const t = useSelector(selectTranslate)

  const handleCancel = useCallback(() => {
    if (isFunction(onCancel)) {
      onCancel(destination)
    }
  }, [destination, onCancel])

  const concurrentGroups = useMemo(() => getConcurrentGroups(sources, destination, toTransfert), [destination, sources, toTransfert])

  const concurrentSections = useMemo(() => isNonEmptyArray(concurrentGroups) ? intersectionBy(concurrentGroups?.flatMap(group => group.sections), toTransfert, ID) : toTransfert, [concurrentGroups.sections, toTransfert])

  return (
    <div className='pd-12 m-4'>
      <div className='mb-12 pdr-8 pdl-8 tx-alg-jus'>
        <h3 className='mb-4'>{t('transfer_sections_panel.title.conflict')}</h3>

        <div className='modal-inner-container warning flex-row ai-ctr'>
          <FontAwesomeIcon
            icon={faTriangleExclamation}
            color='goldenrod'
            style={{
              marginBottom: '24px'
            }}
          />
          <div className='ml-8'>
            <span>{t('transfer_sections_panel.warning.p1')}</span>
            <br />
            <span>{t('transfer_sections_panel.warning.p2')}</span>
          </div>
        </div>
      </div>

      <div className='textual-content pdr-8 pdl-8 tx-alg-jus'>
        <div className='source-groups-list mb-12'>
          <span>{t('transfer_sections_panel.message.p1.1')}</span>

          <ul className='mt-4 mb-4'>
            {concurrentSections.map((s, i) => (
              <li className='mb-4'>
                <ColoredTag key={s.id}>
                  <span>{s.name}</span>
                </ColoredTag>
              </li>
            ))}
          </ul>

          <span>{t('transfer_sections_panel.message.p1.2')}</span>

          <ColoredTag className='mr-2-i' tagColor={TagColors.MAGENTA}>
            <span>{destination.name}</span>
          </ColoredTag>.
        </div>

        <div className='concurrent-groups-list'>
          <span>{t('transfer_sections_panel.message.p2')}</span>

          <ul className='mt-4 mb-20'>
            {concurrentGroups.map(s => (
              <li className='mb-4'>
                <ColoredTag key={s.id} tagColor={TagColors.MAGENTA}>
                  <span>{s.name}</span>
                </ColoredTag>
              </li>
            ))}
          </ul>
        </div>

        <div className='resolution-footer'>
          <h3 className='mb-4'>{t('transfer_sections_panel.title.resolve')}</h3>
          <span>{t('transfer_sections_panel.message.p3')}</span>
          <p>{t('transfer_sections_panel.message.p4')}</p>
          <span>{t('transfer_sections_panel.message.p5')}</span>
        </div>
      </div>

      <ConfirmFormFooter
        confirmIcon={faArrowRightArrowLeft}
        divider
        confirmTitle={'transfer_sections_panel.button.change_section'}
        disabled={loading}
        onCancel={handleCancel}
        onConfirm={onConfirm}
      />
    </div>
  )
}

export default TransferSectionsPanel